import React, {createContext, useContext, useState} from 'react'


const UpdateFormContext = createContext(null);

export const useUpdateForm = () => {
    const context = useContext(UpdateFormContext);
    if (!context) {
        throw new Error('useUpdateForm must be used within a UpdateFormProvider');
    }
    return context;
}

const UpdateFormProvider = ({children}) => {
    const [updateFormValues, setUpdateFormValues] = useState(null);

  return (
    <UpdateFormContext.Provider value={{updateFormValues, setUpdateFormValues}}>
      {children}
    </UpdateFormContext.Provider>
  )
}

export default UpdateFormProvider